import { required } from 'vuelidate/lib/validators'

export default {
  graduation: {
    label: {
      required
    },
    entity: {
      required
    },
    year: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/graduations/form/resources/validations.js